import type { IAccountHealth } from '@ViewModels';
import { css, type StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface HealthScoreCircleProps {
	health?: IAccountHealth;
	styles?: StyleDeclarationValue[];
}

export const HealthScoreCircle: React.FC<HealthScoreCircleProps> = ({ health, styles = [] }) => {
	const rawScore = health?.healthScore;
	const maxScore = health?.healthScoreMax;
	if (rawScore == null || !maxScore) {
		return (
			<span
				className={css(styleSheet.healthScoreCircle, styleSheet.healthScoreNA, ...styles)}
				title='Health Score: N/A'
			>
				N/A
			</span>
		);
	}

	const score = Math.round((rawScore / maxScore) * 100);
	let colorStyle: StyleDeclarationValue = styleSheet.healthScoreRed;
	if (score >= 65) colorStyle = styleSheet.healthScoreGreen;
	else if (score >= 45) colorStyle = styleSheet.healthScoreOrange;

	return (
		<span className={css(styleSheet.healthScoreCircle, colorStyle, ...styles)} title={`Health Score: ${score}`}>
			{score}
		</span>
	);
};
